import FieldErrors from './FieldErrors';
import { useContextualFieldName } from './DocumentLocationsContexts';

export default function ContextualFieldErrors() {
    const fieldName = useContextualFieldName();

    return <FieldErrors fieldName={fieldName} />;
}
